export default "__VITE_ASSET__CamImFWI__";